<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// AI中台管理系统主应用
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}

.el-card {
  border: none !important;
}

.el-card__body {
  padding: 20px;
}
</style>
